import React, { createContext, useContext, useReducer } from 'react';

const FilterContext = createContext<any>(undefined);
interface FilterContextProps {
  children: React.ReactNode;
}

enum Type {
  SEARCH = 'SEARCH',
  SEARCH_BY = 'SEARCH_BY',
  SORT = 'SORT',
  FILTERS = 'FILTERS',
}
interface ActionType {
  type: Type.SEARCH | Type.SEARCH_BY | Type.SORT | Type.FILTERS;
  payload?: any;
}

const filterHandler = (state: boolean, action: ActionType): any => {
  switch (action.type) {
    case Type.SEARCH: {
      return {};
    }
    case Type.SEARCH_BY: {
      return {};
    }
    default:
      return state;
  }
};

export const FilterProvider: React.FC<FilterContextProps> = ({ children }) => {
  const [filters, dispatch] = useReducer(filterHandler, {});

  return (
    <FilterContext.Provider value={{ filters, dispatch }}>
      {children}
    </FilterContext.Provider>
  );
};

export const useFilter = () => {
  const context = useContext(FilterContext);
  if (!context) {
    throw new Error('useFilter must be used within an FilterContext');
  }
  return context;
};
